import { format, isDate, parseJSON } from 'date-fns';

const dateTimeFormat = 'h:mm a M/d/yyyy';
const shortDateFormat = 'M/d/yyyy';

/**
 * Formats a date as a short date string.
 * @param {Date} date A date object.
 * @returns A formatted date string.
 */
export const formatDate = date => (isDate(date) ? format(date, shortDateFormat) : '');

function formatJsonDateWithFormat(date, dateFormat) {
  try {
    return format(parseJSON(date), dateFormat);
  } catch {
    return '';
  }
}

/**
 * Formats a JSON date as a short date string.
 * @param {String} date A JSON date string.
 * @returns A formatted date string, or empty string if date could not be parsed.
 */
export const formatJsonDate = date => formatJsonDateWithFormat(date, shortDateFormat);

/**
 * Formats a JSON date as a long date string.
 * @param {String} date A JSON date string.
 * @returns A formatted date string, or empty string if date could not be parsed.
 */
export const formatJsonDateTime = date => formatJsonDateWithFormat(date, dateTimeFormat);

/**
 * Evaluates whether the value is a Date object or a JSON date string and returns
 * it as a Date object, parsing it if it is a string.
 * @param {Date|String} value A value that is either a Date object or a JSON
 *  date string.
 * @returns The value as a Date object.
 */
export const asDate = value => (isDate(value) ? value : parseJSON(value));
